import { OpenWith } from "@mui/icons-material";
import image from "assets/img/default/pie.png";
import PaperButton from "components/buttons/PaperButton";
import CustomDragTable from "components/CustomDragTable";
import CustomImage from "components/CustomImage";
import { currency } from "lib/formatter";
import { SortableHandle } from "react-sortable-hoc";

export default function FlavoursTable({
  data = [],
  onView = () => {},
  onSortEnd = () => {},
}) {
  const RowHandler = SortableHandle(() => <OpenWith />);
  return (
    <div>
      <CustomDragTable
        data={data}
        height={650}
        pageCount={20}
        onSortEnd={onSortEnd}
        columns={[
          {
            label: "Image",
            selector: "image",
            cellCSS: "p-0",
            sortable: "no",
            cell: (row) => (
              <CustomImage
                src={row?.image ?? image}
                title={row?.name ?? ""}
                className="h-20 w-20"
              />
            ),
          },
          { label: "Name", selector: "name" },
          {
            label: "Description",
            selector: "description",
            cell: (row) => (
              <div
                dangerouslySetInnerHTML={{
                  __html: row?.description ?? "",
                }}
              />
            ),
          },
          {
            label: "Price(Subscription)",
            selector: "price",
            cell: (row) => currency.format(row?.price),
          },
          {
            label: "Price(One off order)",
            selector: "price_oneoff",
            cell: (row) => currency.format(row?.price_oneoff),
          },
          {
            label: "",
            selector: "actions",
            cell: (row, rowIndex) => (
              <div className="flex justify-center">
                <PaperButton
                  onClick={() => onView(row, rowIndex)}
                  variant="text"
                  color="primary"
                >
                  View Flavour
                </PaperButton>
              </div>
            ),
          },
          {
            label: "",
            selector: "actions",
            cell: (row, rowIndex) => (
              <div className="flex justify-center">
                <RowHandler />
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}
